<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import Form from '~@/Components/Products/ProductSubTypes/Form.vue'

defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

function submitForm (form) {
    return form.post(route('products.sub-types.store'))
}
</script>
